(function () {
  function toInt(v) {
    var n = parseInt(v, 10);
    return isFinite(n) ? n : null;
  }

  function initAll(root) {
    (root || document).querySelectorAll(".mauhk-lowstock-wrap").forEach(function (wrap) {
      if (wrap.dataset.mauhkInit === "1") return;
      wrap.dataset.mauhkInit = "1";

      var p = wrap.querySelector(".mauhk-lowstock");
      var textEl = wrap.querySelector(".mauhk-lowstock__text");
      var countEl = wrap.querySelector(".mauhk-lowstock__count"); // optioneel
      var variantsEl = wrap.querySelector(".mauhk-lowstock-variants");

      if (!p || !textEl || !variantsEl) return;

      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) {}

      var threshold = toInt(wrap.dataset.threshold);
      if (threshold === null) threshold = 3;

      var scope = wrap.closest("product-info") || wrap.closest("main") || document;

      function getVariantId() {
        var idInput =
          scope.querySelector('form[action*="/cart/add"] input[name="id"]') ||
          scope.querySelector('input[name="id"]');
        return idInput ? toInt(idInput.value) : null;
      }

      function hide() {
        textEl.textContent = "";
        if (countEl) countEl.textContent = "";
        p.hidden = true;
      }

      function show(qty) {
        var template = wrap.dataset.template || "Nog {count} stuks van deze drop in stock";
        textEl.textContent = template.replace("{count}", qty);

        if (countEl) {
          var showCount = (wrap.dataset.showCount || "false") === "true";
          countEl.textContent = showCount ? " (" + qty + " left)" : "";
        }

        p.hidden = false;
      }

      function update() {
        var variantId = getVariantId();
        if (!variantId) return hide();

        var v = variants.find(function (x) { return x && x.id === variantId; });
        if (!v) return hide();

        if (!v.inventory_management) return hide();

        var qty = toInt(v.inventory_quantity);
        if (qty === null || qty <= 0) return hide();

        if (qty > threshold) return hide();

        return show(qty);
      }

      update();
      scope.addEventListener("change", update, true);
      scope.addEventListener("input", update, true);

      var last = null;
      setInterval(function () {
        var now = getVariantId();
        if (now && now !== last) { last = now; update(); }
      }, 250);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
